import { Container, Row, Col } from 'react-bootstrap';
import { Suspense } from 'react';
import { Spinner } from 'react-bootstrap';
import BlockOverview from './BlockOverview';

const BlocksPage = () => {
    return (
        <div className="blocks-page">
            <Container className="fourthRow webpage" fluid>
                <Row>
                    <Col xs={12}>
                        <div className="table-card">
                            <h3 className="section-header">Recent Blocks</h3>
                            <Suspense
                                fallback={
                                    <div className="text-center py-2">
                                        <Spinner animation="border" size="sm" variant="primary" />
                                    </div>
                                }
                            >
                                <BlockOverview lines={40} />
                            </Suspense>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default BlocksPage;